import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import '../../css/ui-elements/tooltips.css';
import connect from 'react-redux/es/connect/connect';
import hasAccess from "../../helpers/permissionChecker";

class Menu extends Component {
  constructor(props) {
    super(props)
    this.toggle = this.toggle.bind(this);
    this.addPopover = this.addPopover.bind(this);
    this.deletePopover = this.deletePopover.bind(this);
    this.state = {
      isOpen: false,
      showQuickLinks: true
    }
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    })
  }

  addPopover({ config: { layout } }, container) {
    if (layout === 'collapsed-sidebar-1') {
      container.popover({
          placement: "right",
          trigger: "hover"
        }
      );
    }
  }

  deletePopover(container) {
    container.popover('dispose');
  }

  componentWillUnmount() {
    this.deletePopover($('.menu-has-popover'));
  }

  componentDidMount() {
    const menuOption = $('.menu-has-popover');
    this.deletePopover(menuOption);
    this.addPopover(this.props, menuOption);
    let {items} = this.props;
    if (items.title === "Quick Links") {
      let showQuickLinks = true;
      let hasOneAccess = false;
      for (let i in items.items) {
        if (hasAccess(items.items[i].permissions)) {
          hasOneAccess = true;
        }
      }
      showQuickLinks = hasOneAccess;
      this.setState({showQuickLinks});
    }
  }

  componentDidUpdate() {
    const menuOption = $('.menu-has-popover');
    this.deletePopover(menuOption);
    this.addPopover(this.props, menuOption);
  }

  render() {
    let {items} = this.props;
    const activeClass = window.location.href.indexOf(items.url) !== -1 ? ' active' : '';
    if (items.items.length === 0) {
      return (
        <li className='menu-has-popover'
            data-content={items.title}
        >
          <Link
            to={items.url}
            className={`btn btn-default btn-flat btn-sidebar btn-sidebar-1${activeClass}`}
          >
            <i className="material-icons">{items.icon}</i>
            <span className="title">{items.title}</span>
            {items.badge && (
              <span className={`ml-auto ${items.badge.className}`}>
                {items.badge.title}
              </span>
            )}
          </Link>
        </li>
      )
    } else {
      return (
        <li>
          {this.state.showQuickLinks &&
            <a
              className={
                this.state.isOpen
                  ? 'btn btn-default btn-flat btn-sidebar btn-sidebar-1 has-children is-open'
                  : 'btn btn-default btn-flat btn-sidebar btn-sidebar-1 has-children'
              }
              onClick={this.toggle}>
              <i className="material-icons">{items.icon}</i>
              <span className="title">{items.title}</span>
              {items.badge && (
                <span className={`ml-auto ${items.badge.className}`}>
                {items.badge.title}
              </span>
              )}
            </a>
          }
          <ul className="list-unstyled">
            {items.items.map((item, k) => {
              if (hasAccess(item.permissions)) {
                return (
                  <li key={k}>
                    <Link
                      to={item.url}
                      className="btn btn-default btn-flat btn-sidebar btn-sidebar-2">
                      <i className="material-icons">{item.icon}</i>
                      <span className="title">{item.title}</span>
                    </Link>
                  </li>
                )
              }
            })}
          </ul>
        </li>
      )
    }
  }
}

const mapStateToProps = (state) => {
  return {
    config: state.config
  }
};
export default connect(mapStateToProps)(Menu)



// WEBPACK FOOTER //
// ./src/elements/left-sidebar/Menu.js